import React from "react";
import "./Features.css";

function Features() {
  return (
    <>
      <section className="tab_contengt_holder">
        <p className="tab_text">
          To help live you a healthier life, we have for you, the GPAC x
          Copperkraft hand-crafted Copper carafes, with the following features:
          1500 ml capacity Made of pure 99.5%+ food-grade Copper Bedside carafe
          / pitcher has a built-in tumbler that doubles up as its lid
          Hand-crafted by skilled artisans using techniques passed on through
          generations The Copper-ware products from the Gaurav Pradhan Autograph
          Collection would be engraved with Dr. Gaurav Pradhan's (gp) logo, to
          make them stand out! This Uri will have the GP logo engraved on its
          tumbler-cum-lid. Please note that the inside of this Copper vessel is
          darker in colour, which is the natural & unpolished colour of Copper.
          This is so because we do not use any harmful chemicals and polishes to
          brighten the areas that come in contact of your drinking water.
        </p>

        <ul>
          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>

          <li>
            <p className="tab_text">
              Clean the outer body with a salt sprinkled on half-cut lemon{" "}
            </p>
          </li>
        </ul>
        <div className="row">
          <div className="col-xl-4 col-lg-7 col-md-6 col-12">
            <h3 className="additional_title">Additional Information</h3>

            <div className="additional_info_box">
              <div className="info_row">
                <p className="info_label">Weight (Grams)</p>
                <span className="info_dots"></span>
                <p className="info_value">480.0000</p>
              </div>

              <div className="info_row">
                <p className="info_label">Thickness (Mm)</p>
                <span className="info_dots"></span>
                <p className="info_value">No</p>
              </div>

              <div className="info_row">
                <p className="info_label">Diameter (Mm)</p>
                <span className="info_dots"></span>
                <p className="info_value">72</p>
              </div>

              <div className="info_row">
                <p className="info_label">Material</p>
                <span className="info_dots"></span>
                <p className="info_value">Copper</p>
              </div>

              <div className="info_row">
                <p className="info_label">Country Of Manufacture</p>
                <span className="info_dots"></span>
                <p className="info_value">India</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Features;
